export default __webpack_public_path__ + "static/media/logistics-logo.a626bf7e.png";